import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useSelectStyles } from '../../utils/selectStyles';
import DateRangeSelector from '../DateRangeSelector';
import { useSearchParams } from 'react-router-dom';

const GIAIReportSelectionHeader = ({
  clients,
  selectedClient,
  setSelectedClient,
  startDate,
  endDate,
  onDatesChange,
  loading
}) => {
  const [searchParams] = useSearchParams();
  const selectStyles = useSelectStyles();
  const [isExpanded, setIsExpanded] = useState(true);
  const isInIframe = (window.self !== window.top || searchParams.has('embed')) && searchParams.has('clientId');

  // Vérifier si on a un clientId dans l'URL
  const [hasClientIdInUrl, setHasClientIdInUrl] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get('clientId');
    setHasClientIdInUrl(!!clientId);
  }, []);

  // Déterminer si on doit masquer le sélecteur de client
  const shouldHideClientSelector = isInIframe && hasClientIdInUrl;

  // Fonction pour afficher un résumé des filtres appliqués
  const getFilterSummary = () => {
    const parts = [];

    if (selectedClient && !shouldHideClientSelector) parts.push(selectedClient.label);

    if (startDate && endDate) {
      const start = startDate.toLocaleDateString('fr-FR');
      const end = endDate.toLocaleDateString('fr-FR');
      parts.push(`${start} - ${end}`);
    }

    return parts.join(' • ');
  };

  return (
    <div className="py-4 mb-6 relative z-20">
      {/* Toggle header pour mobile/tablet - masqué en desktop */}
      <div
        className="flex items-center justify-between cursor-pointer md:hidden relative"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {/* Titre centré - affiché uniquement quand le composant est déplié */}
        {isExpanded && (
          <div className="absolute inset-x-0 text-center">
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Filtres</div>
          </div>
        )}

        {/* Résumé des filtres - affiché uniquement quand replié */}
        <div className={`flex-1 ${isExpanded ? 'invisible' : 'visible'} max-w-[calc(100%-2rem)]`}>
          {!isExpanded && (
            <div
              className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 text-left"
              dangerouslySetInnerHTML={{ __html: getFilterSummary() }}
            />
          )}
        </div>

        {/* Chevron (à droite) */}
        <div className="ml-3 z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 ${isExpanded ? 'transform rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Contenu du filtre - toujours visible en desktop */}
      <div className={`${isExpanded ? 'block' : 'hidden'} md:block md:pt-0 pt-4`}>
        <div className={`grid gap-3 ${shouldHideClientSelector ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'}`}>
          {/* Sélection de client - masqué si en iframe avec clientId */}
          {!shouldHideClientSelector && (
            <div>
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">
                Client
              </label>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={clients}
                value={selectedClient}
                onChange={setSelectedClient}
                isLoading={loading}
                placeholder="Sélectionner un client..."
                isDisabled={loading}
                menuPortalTarget={document.body}
                isClearable={true}
                styles={selectStyles}
              />
            </div>
          )}

          {/* Sélection de dates - prend toute la place si client masqué */}
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">
              Période
            </label>
            <DateRangeSelector
              startDate={startDate}
              endDate={endDate}
              onDatesChange={onDatesChange}
              maxDateRange={{ value: 12, unit: 'months' }}
              relative={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GIAIReportSelectionHeader;